"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_state_1 = require("prosemirror-state");
var util_1 = require("../../libs/util");
exports.cardSingleClick = function (_a) {
    var node = _a.node, nodePos = _a.nodePos, view = _a.view;
    if (node.type.spec.sylCard) {
        var _b = view.state, tr = _b.tr, doc = _b.doc, dispatch = view.dispatch;
        var newSelection = prosemirror_state_1.NodeSelection.create(doc, nodePos);
        dispatch(tr.setSelection(newSelection));
        return true;
    }
    return false;
};
exports.cardInput = function (_a) {
    var view = _a.view, event = _a.event;
    var tr = view.state.tr, dispatch = view.dispatch;
    // 选中块输入时，需先把块删除
    if (util_1.Utils.checkIsPrintableKey(event) &&
        tr.selection instanceof prosemirror_state_1.NodeSelection) {
        dispatch(tr.deleteSelection());
    }
    return false;
};
//# sourceMappingURL=card.js.map